export const TESTING = {
  cms: {
    default: 'delivery-frontend-cms.taxi.tst.yandex.net',
    authorized: 'delivery-frontend-cms.taxi.tst.yandex-team.ru',
  },
  'logistics-frontend': {
    default: 'logistics-frontend.taxi.tst.yandex.net',
    authorized: 'logistics-frontend.taxi.tst.yandex.ru',
  },
  'static-com': {
    default: 'static-com.taxi.tst.yandex.net',
    authorized: 'delivery.tst.yandex.com',
    by: 'delivery.tst.yandex.by',
    kg: 'delivery.tst.yandex.kg',
    kz: 'delivery.tst.yandex.kz',
    uz: 'delivery.tst.yandex.uz',
  },
  'static-ru': {
    default: 'frontend-static-yango.taxi.tst.yandex.net',
  },
  'static-yango': {
    default: 'static-yango.taxi.tst.yandex.net',
    authorized: 'delivery.tst.yango.com',
  },
} as const
